// Généré automatiquement par generate-build-info.js - NE PAS MODIFIER
// Ce fichier est regénéré à chaque build
export const VERSION_INFO = {
  version: '0.2.0',
  buildDate: '2026-07-24',
  buildTime: '17h59',
  buildTimeISO: '2026-07-24T15:59:21.807Z',
  cacheVersion: 'v0.2.0-2026-07-24-17h59'
};
